// https://scotch.io/tutorials/angular-2-transclusion-using-ng-content
// https://blog.thoughtram.io/angular/2016/09/16/angular-2-animation-important-concepts.html

import { Component, Input, trigger, state, animate, transition, style } from '@angular/core';

@Component({
  selector: 'app-fader',
  animations: [
    trigger('visibilityChanged', [
      state('true', style({ opacity: 1 })),
      state('false', style({ opacity: 0 })),
      transition('* => *', animate('.5s')),
    ])
  ],
  templateUrl: './fader.component.html',
  styleUrls: ['./fader.component.scss']
})

export class FaderComponent {

  @Input() public isVisible: string = 'false';

  constructor() { }
}



// WEBPACK FOOTER //
// ./src/app/shared/fader/fader.component.ts